mutation ReopenStream($contentId: ID!) {
  reopenStream(contentId: $contentId) {
    id
    stream {
      id
      status
      startAt
      finishAt
    }
  }
}
